import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom Mathematical Comparison Icons for Material UI
 * Usage: <CustomSvgIcons.GreaterThan sx={{ color: '#162936', fontSize: '16px' }} />
 */

const GreaterThan: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M8 6L16 12L8 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const LessThan: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M16 6L8 12L16 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const GreaterThanEqual: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M8 5L16 10L8 15M7 18H17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const LessThanEqual: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M16 5L8 10L16 15M7 18H17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const CustomSvgIcons = {
  GreaterThan,
  LessThan,
  GreaterThanEqual,
  LessThanEqual,
};

export default CustomSvgIcons;
